<template>
	<div v-show="showFlag">
		<payHeader :bgStatus="bgStatus"></payHeader>
		<div class="user-repwd appeal-form">
			<div class="container">
				<div class="head">
					<h1>账号申诉</h1>
					<ul>
						<li class="step1 active">验证账号</li>
						<li class="step2 active">实名认证</li>
						<li class="step3">申诉资料</li>
						<li class="step4">等待审核</li>
					</ul>
				</div>
				<el-alert type="warning" show-icon :closable="false" style="margin: 20px 48px 0;">
					<template #title>
					    申诉需要完成实名认证提交，请务必保证个人身份信息与新手机号一致，避免因信息不匹配导致认证失败 全部资料仅用于身份验证并受到<a :href="domain+'/agreement/statement.html'" target='_blank'>《蓝队云隐私政策》</a>保护
					</template>
				</el-alert>
				<el-form :rules="rules" ref="ruleFormRef" inline-message :model="groupForm" :label-width="formLabelWidth">
					<el-form-item label="认证方式">
						<el-radio-group v-model="way">
						  <el-radio label="mobile" border>手机号</el-radio>
						  <!-- <el-radio label="bankno" border>银行卡号</el-radio> -->
						</el-radio-group>
					</el-form-item>
					<el-form-item label="认证费用">
						<el-text type="danger" size="large">1.5元</el-text><el-text type="info">（认证费用用于支付三大运营商及银联实名认证接口费用）</el-text>
					</el-form-item>
					<el-form-item label="原登录账号">
					  <el-input v-model="account" disabled autocomplete="off" />
					</el-form-item>
					<el-form-item label="姓名" prop="trueName">
						<el-input v-model="groupForm.trueName" autocomplete="off" />
					</el-form-item>
					<el-form-item label="身份证号" prop="IDCard">
						<el-input v-model="groupForm.IDCard" autocomplete="off" />
					</el-form-item>
					<el-form-item label="新手机号" prop="mobile">
						<el-input v-model="groupForm.mobile" autocomplete="off" />
					</el-form-item>
					<el-form-item label="银行卡号" prop="bankNo" v-if="way == 'bankno'">
						<el-input v-model="groupForm.bankNo" autocomplete="off" />
					</el-form-item>
					<div class="code">
					  <el-form-item label="验证码" :rules="[{ required: true }]">
					    <el-input v-model="code" autocomplete="off" />
					  </el-form-item>
					  <el-button type="primary" :disabled="codeSend" @click="codeChange">{{codeSendText}}</el-button>
					</div>
					<el-form-item label="邮箱" prop="email">
						<el-input v-model="groupForm.email" autocomplete="off" />
					</el-form-item>
					<p class="form-tip" style="margin-left: 100px;">用来接收申诉通知结果</p>
					<el-form-item label="支付方式">
						<p class="pay" v-for="(item, index) in payOptions" :key="index" @click="payChange(item.key)" :class="{ 'active': payType === item.key }"><span :class="item.type"></span></p>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="submitForm">点击支付，前去实名认证</el-button>
					</el-form-item>
				</el-form>
				<el-dialog align-center :close-on-click-modal="false" v-model="captchaVisible" title="请输入图片中的验证码" width="280">
					<el-image :src="captchaImg" @click="captchaReload" fit="contain" alt="验证码" title="点击刷新" style="margin-bottom: 10px;cursor: pointer;" />
				    <el-form-item label="验证码">
				      <el-input v-model="captchaAnswer" autocomplete="off" />
				    </el-form-item>
				    <template #footer>
				      <div class="dialog-footer">
				        <el-button type="primary" @click="sendCodeClick">发送验证码</el-button>
				      </div>
				    </template>
				</el-dialog>
				<el-dialog align-center :close-on-click-modal="false" v-model="payVisible" title="支付" @close="payCancel">
					<div class="pay-main">
						<h3>请使用{{payType == 1 ? '微信':'支付宝'}}“扫一扫”功能扫描下方二维码进行支付</h3>
						<p class="tip">本次认证需要花费<el-text type="danger" size="large">1.5</el-text>元，支付后无法退款，请确认后再支付。</p>
						<div class="ewm"><el-image :src="codeImg" style="width: 160px;"></el-image></div>
					</div>
				    <template #footer>
				      <div class="dialog-footer">
				        <el-button type="primary" @click="payCancel">取消支付</el-button>
				      </div>
				    </template>
				</el-dialog>
			</div>
		</div>
		<payFooter></payFooter>
	</div>
</template>

<script setup>
	import { ref,reactive,inject,onBeforeUnmount,onMounted} from 'vue';
	import { useRouter } from 'vue-router';
	import { captchaFetch,appealSmscode,appealAuth,appealPay,appealOrder,appealStep,appealVerify } from '@/api/home';
	import { ElMessage, } from 'element-plus';
	import { payHeader,payFooter } from 'landui-ui';
	
	let timerId = null;
	const bgStatus = ref(true);
	const router = useRouter();
	const showFlag = ref(false);
	const domain = inject('domain');
	const account = ref('');
	const way = ref('mobile');
	const payVisible = ref(false);
	const payType = ref(1);
	const payOptions = reactive([
		{
			key: 1,
			type: 'wx'
		},
		{
			key: 2,
			type: 'zfb'
		}
	]);
	const codeImg = ref('');
	const orderid = ref('');
	const code = ref('');
	const codeSendText = ref('获取验证码');
	const codeSend = ref(false);
	const codeTime = ref(60);
	const captchaVisible = ref(false);
	const captchaAnswer = ref('');
	const captchaImg = ref('');
	const captchaId = ref('');
	const formLabelWidth = ref('100px');
	const ruleFormRef = ref(null);
	const groupForm = ref({trueName:'',IDCard:'',mobile:'',bankNo:'',email:''});
	const rules = reactive({
		trueName: [
			{ required: true, message: '请填写真实姓名', trigger: 'blur' }
		],
		IDCard: [
			{ required: true, message: '请填写身份证号码', trigger: 'blur' }
		],
		mobile: [
			{ required: true, message: '请填写新手机号码', trigger: 'blur' }
		],
		bankNo: [
			{ required: true, message: '请填写银行卡号', trigger: 'blur' }
		],
		email: [
			{ required: true, message: '请填写接收邮箱地址', trigger: 'blur' }
		]
	});

	const appealStepF = () => {
		appealStep().then((res) => {
			if (res.code == 200) {
				switch(res.data.step)
				{
					case 0:
						router.push({ path: '/appeal' })
					break;
					case 1:
						showFlag.value = true;
					break;
					case 2:
						router.push({ path: '/appealInfo' })
					break;
					case 3:
						router.push({ path: '/appealStatus' })
					break;
				}
			}
		})
	}
	const payChange = (key) => {
		payType.value = key;
	};
	const captchaChange = () => {
		captchaFetch().then((res) => {
			if (res.code == 200) {
				captchaImg.value = res.data.captcha_data;
				captchaId.value = res.data.captcha_id;
			}
		})
	}
	const codeChange = () => {
		if (groupForm.value.mobile == '') {
			ElMessage({
				offset: 110,
				message: '请填写手机号码',
				type: 'error'
			})
		} else{
			captchaChange()
			captchaVisible.value = !captchaVisible.value;
		}
	}
	const sendCodeClick = () => {
		const param = {
			'captcha_answer':captchaAnswer.value,
			'captcha_id':captchaId.value,
			'mobile':groupForm.value.mobile
		}
		appealSmscode(param).then((res) => {
			if (res.code == 200) {
				codeSend.value = true;
				codeSendText.value = codeTime.value+'s后重新发送';
				let timer = setInterval(() => {
				   codeTime.value--;
				   codeSendText.value = codeTime.value + 's后重新发送';
				   if (codeTime.value < 0) {
					   clearInterval(timer);
					   codeSendText.value = '获取验证码';
					   codeTime.value = 60;
					   codeSend.value = false
				   }
				}, 1000)
				captchaVisible.value = !captchaVisible.value;
			}else{
				captchaChange()
				captchaAnswer.value = ''
			}
		})
	}
	const submitForm = () => {
		if (!ruleFormRef.value) return;
		ruleFormRef.value.validate((valid) => {
			if (valid) {
				const param = groupForm.value;
				param['account'] = account.value;
				param['payType'] = payType.value;
				param['code'] = code.value;
				param['way'] = way.value;
				appealAuth(param).then((res) => {
					if (res.code == 200) {
						orderid.value = res.data.orderId;
						localStorage.setItem('appealuserId', res.data.userId);
						appealPayF(res.data.orderId,res.data.userId)
						payVisible.value = !payVisible.value
					}
				})
			} else {
			  return false;
			}
		});
	};
	const appealPayF = (order,id) => {
		const param = {
			'orderid':order,
			'id':id
		}
		appealPay(param).then((res) => {
			if(res.code === 200){
				codeImg.value = res.info.qrcode;
				timerId = setInterval(appealOrderF, 3000);
			}
		})
	}
	const appealOrderF = () => {
		appealOrder(orderid.value).then((res) => {
			if(res.code === 200){
				clearInterval(timerId);
				timerId = setInterval(appealVerifyF, 3000);
			}
		})
	}
	const appealVerifyF = () => {
		appealVerify().then((res) => {
			if(res.code === 200){
				clearInterval(timerId);
				router.push({ path: '/appealInfo' })
			}
		})
	}
	const payCancel = () => {
		clearInterval(timerId);
		payVisible.value = false;
	}
	const captchaReload = () => {
		captchaChange()
	}
	
	onMounted(() => {
		account.value = localStorage.getItem('appealAccount');
		appealStepF()
	})
	onBeforeUnmount(() => {
		clearInterval(timerId); 
	});
	
</script>

<style lang="scss" scoped>
	.user-repwd{
		.el-form{
			padding-left: 380px;
			width: auto;
			.el-form-item {
				.el-input {
					width: 46% !important;
				    --el-input-height: auto !important;
				}
				.el-input__inner{padding: 1px 11px !important;}
			} 
			.code{
				.el-form-item{
					width: 40%;
					.el-input {
						width: 100% !important;
					}
				}
			}
		}
		.head h1{background: url(../../assets/images/appeal_icon.png) no-repeat left center;}
		.pay{
			float: left;
			border: 1px solid #ddd;
			position: relative;
			margin: 0 10px 5px 0;
			padding: 0 20px;
			cursor: pointer;
			span{display: block;height: 40px; width: 108px;}
			.wx{background: url(../../assets/images/bank1.jpg) no-repeat center; background-size: contain;}
			.zfb{background: url(../../assets/images/bank2.jpg) no-repeat center; background-size: contain;}
		}
		.pay.active{color: #015BFE;border-color: #015BFE;background: url(../../assets/images/active.png) right bottom no-repeat;}
		.pay-main{
			text-align: center;
			overflow: hidden;
			.tip{margin-top: 10px; color: #999;margin-bottom: 24px;}
			.ewm{border: 1px solid #ddd; width: 162px; height: 162px; margin: 0 auto;}
		}
	}
</style>